import * as React from 'react'
import styled from 'styled-components'
import Linkify from 'react-linkify'

const Description = ({ children, ...props }) => {
  const P = styled.p`
    white-space: pre-wrap;
  `

  return (
    <P {...props}>
      <Linkify>{children}</Linkify>
    </P>
  )
}

export default Description
